export default __webpack_public_path__ + "static/media/phoneSplit.1dc8324a.png";